import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { ForgotPassword } from "../../utils/Constant";
import { useState, useEffect } from "react";
import { Eye, EyeOff } from "react-feather";
import { useAuth } from "../../hooks/useAuth";

const Login = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirigir si ya está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard/default", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const SimpleLoginHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      await login({
        username: email, // El backend espera 'username' pero puede ser email
        password: password,
      });
      
      // La navegación se manejará automáticamente por el useEffect
      navigate("/dashboard/default", { replace: true });
    } catch (error) {
      // El error ya se maneja en el AuthContext con toast
      console.error('Error en login:', error);
    }
  };
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <div className="logo text-center">
                  <Image className="img-fluid for-light mx-auto" src={dynamicImage("logo/logo.png")} alt="logo" width={450} />
                </div>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={(e) => SimpleLoginHandle(e)} >
                  <FormGroup>
                    <Label className="col-form-label">Correo</Label>
                    <Input type="email" required placeholder="ejemplo@email.com" value={email} name="email" onChange={(event) => setEmail(event.target.value)} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">Contraseña</Label>
                    <div className="form-input position-relative">
                      <Input type={show ? "text" : "password"} placeholder="*********" onChange={(event) => setPassword(event.target.value)} value={password} name="password" />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span>
                          {show ? <EyeOff size={18} color="var(--theme-default)" /> : <Eye size={18} color="var(--theme-default)" />}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title position-relative">
                    <div className="checkbox p-0">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" htmlFor="checkbox1">
                        Recordarme
                      </Label>
                    </div>
                    <Link className="forgot-link" to="/authentication/forgetpassword">
                      Olvidé mi contraseña
                    </Link>
                    <div className="text-end mt-3">
                      <Btn 
                        color="primary" 
                        block 
                        className="w-100" 
                        disabled={isLoading}
                      >
                        {isLoading ? "Iniciando sesión..." : "Iniciar sesión"}
                      </Btn>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
